import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-eye-open-filled",
  "use": "icon-s-eye-open-filled-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-eye-open-filled\"><path d=\"M11 4q3.4 0 6.264 1.674a12.2 12.2 0 0 1 4.469 4.414Q22 10.504 22 11q0 .496-.267.912a12.2 12.2 0 0 1-4.469 4.414Q14.4 18.001 11 18q-3.398 0-6.263-1.674A12.2 12.2 0 0 1 .27 11.912 1.65 1.65 0 0 1 0 11q0-.496.269-.912a12.2 12.2 0 0 1 4.468-4.414Q7.602 3.999 11 4m0 2.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5m0 1.5a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol